import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  useVbsOfferShowQuery,
  useVbsOfferUpdatePostalAddressMutation,
  useVbsOfferUpdateRepresentativeMutation,
  useVbsOfferUpdateServiceAddressMutation,
} from "@/services/backend/vbs/offers/api/offer-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function AddressesAndContactsRoute() {
  const { offerId } = useParams();
  const {
    data: offer,
    isLoading,
    error,
  } = useVbsOfferShowQuery({
    id: offerId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={offer!.id}
        address={offer!.postalAddress}
        mutation={useVbsOfferUpdatePostalAddressMutation}
        disabled={isImmutable(offer!)}
      />
      <ServiceAddressCardWithMutation
        id={offer!.id}
        address={offer!.serviceAddress}
        mutation={useVbsOfferUpdateServiceAddressMutation}
        disabled={isImmutable(offer!)}
      />
      <RepresentativeCardWithMutation
        id={offer!.id}
        representative={offer!.representative}
        mutation={useVbsOfferUpdateRepresentativeMutation}
        disabled={isImmutable(offer!)}
      />
    </div>
  );
}
